import axios, { type AxiosInstance } from 'axios';

const API_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:8000';
const TOKEN_KEY = 'panda_token';

export const apiClient: AxiosInstance = axios.create({
  baseURL: `${API_URL}/api/v1`,
  headers: { Accept: 'application/json' },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // 409 + code=TERMS_VERSION_OUTDATED — server bumped the legal version.
    // Redirect into /accept-terms (preserving the current location as `next`)
    // unless we're already there, in which case let the page handle it.
    if (
      error?.response?.status === 409 &&
      error?.response?.data?.code === 'TERMS_VERSION_OUTDATED' &&
      typeof window !== 'undefined' &&
      !window.location.pathname.startsWith('/accept-terms')
    ) {
      const next = encodeURIComponent(window.location.pathname + window.location.search);
      window.location.href = `/accept-terms?next=${next}`;
    }

    // 401 = expired/invalid token. Strip it and let the auth provider
    // re-render the login surface; we don't redirect here so tests stay
    // controllable and the consumer can show a toast.
    if (error?.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
    }
    return Promise.reject(error);
  },
);

export const tokenStore = {
  get: (): string | null => localStorage.getItem(TOKEN_KEY),
  set: (token: string): void => {
    localStorage.setItem(TOKEN_KEY, token);
  },
  clear: (): void => {
    localStorage.removeItem(TOKEN_KEY);
  },
};
